import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-assets",
  "use": "icon-assets-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-assets\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M7.2,19H4.8a.79.79,0,0,1-.8-.78V5.78A.79.79,0,0,1,4.8,5h5.93l1.6,1.56H19.2a.78.78,0,0,1,.8.77V9.67H8a.78.78,0,0,0-.8.77Zm1.6,0V11.22H20v7a.79.79,0,0,1-.8.78Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol